/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.V2WatchStatus = exports.V2Scope = exports.PresencePresenceStatus = exports.OperationType = exports.NotificationChannel = exports.DeviceType = exports.ApiWatchStatus = exports.ApiScope = exports.ApiPresenceStatus = void 0;
var ApiPresenceStatus;
(function (ApiPresenceStatus) {
    ApiPresenceStatus["ONLINE"] = "ONLINE";
    ApiPresenceStatus["OFFLINE"] = "OFFLINE";
})(ApiPresenceStatus = exports.ApiPresenceStatus || (exports.ApiPresenceStatus = {}));
var ApiScope;
(function (ApiScope) {
    ApiScope["UNKNOWN"] = "UNKNOWN";
    ApiScope["VIEWER"] = "VIEWER";
    ApiScope["EDITOR_X"] = "EDITOR_X";
})(ApiScope = exports.ApiScope || (exports.ApiScope = {}));
var ApiWatchStatus;
(function (ApiWatchStatus) {
    ApiWatchStatus["SUCCESS"] = "SUCCESS";
    ApiWatchStatus["REJECTED"] = "REJECTED";
})(ApiWatchStatus = exports.ApiWatchStatus || (exports.ApiWatchStatus = {}));
var DeviceType;
(function (DeviceType) {
    DeviceType["UNKNOWN"] = "UNKNOWN";
    DeviceType["DESKTOP"] = "DESKTOP";
    DeviceType["MOBILE"] = "MOBILE";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["FIREBASE"] = "FIREBASE";
    NotificationChannel["DUPLEXER"] = "DUPLEXER";
})(NotificationChannel = exports.NotificationChannel || (exports.NotificationChannel = {}));
var OperationType;
(function (OperationType) {
    OperationType["CREATE"] = "CREATE";
    OperationType["UPDATE"] = "UPDATE";
    OperationType["DELETE"] = "DELETE";
})(OperationType = exports.OperationType || (exports.OperationType = {}));
var PresencePresenceStatus;
(function (PresencePresenceStatus) {
    PresencePresenceStatus["UNKNOWN"] = "UNKNOWN";
    PresencePresenceStatus["ACTIVE"] = "ACTIVE";
    PresencePresenceStatus["OFFLINE"] = "OFFLINE";
    PresencePresenceStatus["IDLE"] = "IDLE";
})(PresencePresenceStatus = exports.PresencePresenceStatus || (exports.PresencePresenceStatus = {}));
var V2Scope;
(function (V2Scope) {
    V2Scope["UNDEFINED"] = "UNDEFINED";
    V2Scope["VIEWER"] = "VIEWER";
    V2Scope["EDITOR_X"] = "EDITOR_X";
})(V2Scope = exports.V2Scope || (exports.V2Scope = {}));
var V2WatchStatus;
(function (V2WatchStatus) {
    V2WatchStatus["SUCCESS"] = "SUCCESS";
    V2WatchStatus["REJECTED"] = "REJECTED";
})(V2WatchStatus = exports.V2WatchStatus || (exports.V2WatchStatus = {}));
//# sourceMappingURL=types.js.map